import { render, staticRenderFns } from "./BuyboxBottomPanelFeature.vue?vue&type=template&id=7f90bb44&scoped=true&"
import script from "./BuyboxBottomPanelFeature.vue?vue&type=script&lang=ts&"
export * from "./BuyboxBottomPanelFeature.vue?vue&type=script&lang=ts&"
import style0 from "./BuyboxBottomPanelFeature.vue?vue&type=style&index=0&id=7f90bb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f90bb44",
  null
  
)

component.options.__file = "BuyboxBottomPanelFeature.vue"
export default component.exports